document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]:not(.email-v5)');
    const checkoutBtn = e.target.closest('button[bss-b2b-btn-quickview][type="submit"].xo-btn--block');

    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 1300);
    }

    if (checkoutBtn) {
      BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
    }

    setTimeout(() => {
      const productForms = document.querySelectorAll("[bss-b2b-main-product-form], [bss-b2b-quickview-product-form]");
      productForms.forEach((productForm) => {
        BSS_B2B?.observer?.productSubject?.notifyObserver?.(
          'VariantChange',
          'VariantSelectChange',
          { productForm }
        );
      });
    }, 1300);
  });

  document.querySelectorAll('form[action*="/checkout"] button[type="submit"]').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const productForm = btn.closest('form');
    BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');  

    setTimeout(() => {
      productForm.submit();
    }, 300);
  });
  });
});



const config = {
  selectorCard: '#qikify-stickycart-v2-app .qsc2-product-item-wrapper',
  selectorOriginPrice: '.qsc2-product-item__price',
  selectorFinalLinePrice: '.qsc2-product-item__line-price',
  selectorSubtotalPrice: '.easc-miniCartProductsDiv .eascCartSubtotal .prodRowPrice', 
};

async function addCartPriceAttributes(config) {
  const AjaxCartApi = window.BSS_B2B?.utils?.AjaxCartApi;
  if (!AjaxCartApi) return;

  let lineItems = [];
  try {
    const res = await AjaxCartApi.getCart();
    lineItems = res.items || [];
  } catch (err) {
    window.BSS_B2B?.logger?.error?.('[BSS B2B] Failed to fetch cart.js:', err);
    return;
  }

  const cartItems = document.querySelectorAll('.qsc2-product-item');
  const priceRecommended = document.querySelector('.qsc2-recommended-row--carousel-enabled')
  if (priceRecommended) {
    setTimeout(() => {
      priceRecommended.style.display = 'none'
    }, 500);
    
  }
  cartItems.forEach((item) => {
    const link = item.querySelector('.qsc2-product-item__image img');
    const title = link?.getAttribute('alt');
    if (!title || item.hasAttribute('bss-b2b-cart-item-key')) return;

    const originalEls = config.selectorOriginPrice
      ? Array.from(item.querySelectorAll(config.selectorOriginPrice))
      : [];

    const finalEls = config.selectorFinalLinePrice
      ? Array.from(item.querySelectorAll(config.selectorFinalLinePrice))
      : [];

    const productMatch = lineItems.find((p) =>{
      return p.title.toString().includes(title)
    });
    const itemKey = productMatch?.key;
    if (itemKey) item.setAttribute('bss-b2b-cart-item-key', itemKey);

    finalEls.forEach((el) => {
      el.setAttribute('bss-b2b-final-line-price', '');
      if (itemKey) el.setAttribute('bss-b2b-cart-item-key', itemKey);
    });
    originalEls.forEach((el) => {
      el.setAttribute('bss-b2b-item-original-price', '');
      if (itemKey) el.setAttribute('bss-b2b-cart-item-key', itemKey);
    });
  });

  const totalPrice = document.querySelector('.qsc2-drawer-footer__summary-subtotal-price');
  if (totalPrice && !totalPrice.hasAttribute('bss-b2b-cart-total-price')) {
    totalPrice.setAttribute('bss-b2b-cart-total-price', '');
  }
let buttonCheckout = document.querySelector('.qsc2-basic.qsc2-btn.qsc2-checkout-button');

if (buttonCheckout) {
  let newCheckout = document.createElement('button');
  newCheckout.classList.add('qsc2-basic', 'qsc2-btn', 'qsc2-checkout-button', 'checkout-btn');
  newCheckout.textContent = 'Sicher zur Kassa';
  buttonCheckout.after(newCheckout);
  buttonCheckout.style.display = 'none';
}
}

function observeMiniCartRepeatedly() {
    const targetSelector = '.qikify-stickycart-v2:has(.qsc2-product-item)';
    const mainObserver = new MutationObserver(() => {
        const miniCart = document.querySelector(targetSelector);
        if (miniCart && !miniCart.dataset.bssB2bProcessed) {
            miniCart.dataset.bssB2bProcessed = 'true';
            addCartPriceAttributes(config).then(() => {
                window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');
                BSS_B2B.observer.cartSubject.listenCartCheckout()
                const cartContainer = document.querySelector('.eascProdBox');

                const priceRecommended = document.querySelector('.qsc2-drawer-rows--recommended-products')
                if (priceRecommended) {
                    priceRecommended.style.display = 'none'
                }
                if (cartContainer) {
                    const cartItemsObserver = new MutationObserver((mutations) => {
                        for (const mutation of mutations) {
                            if (mutation.addedNodes.length > 0) {

                                addCartPriceAttributes(config);
                                window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');
                            }
                        }
                    });

                    cartItemsObserver.observe(cartContainer, {
                        childList: true,
                        subtree: false, // bạn có thể bật true nếu cần lắng cả con cháu sâu
                    });
                }
            });
           let VatExempt = document.querySelector('.shopify-block.shopify-app-block .bss-b2b-tax-ex-wrapper ')
           if (VatExempt) {
             
             if (window.location.pathname.includes("cart")) {
             } else {
              let input = document.querySelector('.bss-b2b-vat-input')
              if (BSS_B2B?.shopData?.customer.tags.includes('umsatzsteuerbefreit')) {
                input.value = ''
              }
              let cartCheckout = document.querySelector('.qsc2-drawer-footer__summary-subtotal')
              cartCheckout.after(VatExempt)
             }
           }
        }
    });
     if (window.location.pathname.includes("cart")) {
              let VatExempt = document.querySelector('.shopify-block.shopify-app-block .bss-b2b-tax-ex-wrapper ')
              let cartCheckout = document.querySelector('.xo-cart-totals')
              cartCheckout.before(VatExempt)
              let input = document.querySelector('.bss-b2b-vat-input')
              if (BSS_B2B?.shopData?.customer.tags.includes('umsatzsteuerbefreit')) {
                input.value = ''
              }
    }
    mainObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });

}

document.addEventListener('DOMContentLoaded', observeMiniCartRepeatedly);

